<template>
  <div>
    <a-form-model
      :model="form"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      style="margin-top: 10px;"
      :rules="rules"
      ref="ruleForm"
    >
      <a-form-model-item label="Code" prop="code">
        <a-input ref="code" v-model="form.code" placeholder="Enter text..." />
      </a-form-model-item>
      <a-form-model-item label="Name">
        <a-input
          v-model="form.name"
          placeholder="Enter text..."
          style="width: 100%;"
        />
      </a-form-model-item>
      <a-form-model-item label="Department / Phòng ban">
        <SelectDepartment
          v-model="form.departmentIds"
          :selectProps="{
            value: form.departmentIds,
            mode: 'multiple',
            placeholder: 'Department',
          }"
        />
      </a-form-model-item>
    </a-form-model>
    <div
      :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1,
      }"
    >
      <a-button style="margin-right: 10px;" @click="close">
        Close
      </a-button>
      <a-button type="primary" @click="onSubmit" :loading="loading">
        Create
      </a-button>
    </div>
  </div>
</template>
<script>
import query from "../constant/query";
// components
import SelectDepartment from "@/components/common/department/select";

const defaultForm = { businessesType: undefined };
export default {
  components: { SelectDepartment },

  props: {
    close: { type: Function, required: true },
    refreshAfterCreated: { type: Function, required: true },
  },
  data() {
    return {
      labelCol: { span: 24 },
      wrapperCol: { span: 24 },
      form: { ...defaultForm },
      loading: false,
      rules: {
        code: [
          {
            required: true,
            message: "Required / Code không được bỏ trống",
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    setFormItem(nameForm, value) {
      this.$set(this.form, nameForm, value);
    },
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.onCreatedDepartmentGroup();
        } else {
          return false;
        }
      });
    },

    onCreatedDepartmentGroup() {
      this.loading = true;
      this.$apollo
        .mutate({
          mutation: query.createDepartmentGroup,
          variables: {
            ...this.form,
          },
        })
        .then(({ data }) => {
          this.$notification.success({
            message: "Success",
            description: "Create success!",
          });
          this.loading = false;
          this.form = { ...defaultForm };
          if (data?.createDepartmentGroup?.id) {
            this.refreshAfterCreated(data.createDepartmentGroup);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$notification.error({
            message: "Error",
            description: "Create error!",
          });
          console.error("Thêm department group không thành công", err);
        });
    },
  },
};
</script>
<style scoped>
.ict24h-editor >>> .ql-toolbar.ql-snow {
  padding: 2px !important;
}
</style>
